import { Field } from "chorda-bulma";
import { TextInput } from "../../helpers";
export default () => {
    return Field({
        label: 'Name',
        control: TextInput({
            placeholder: 'Text input'
        })
    });
};
